// delta-display.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-delta-display',
  template: `
    <div [class]="'delta-chip ' + getChipSeverity()">
      {{value > 0 ? '+' : ''}}{{ value }}
    </div>
  `,
  styles: [`
    .delta-chip{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem 0.5rem;
      border-radius: var(--p-border-radius-lg);
      background-color: var(--p-surface-200);
      color: var(--p-text-color);
      font-size: 0.9rem;
      line-height: 0.9rem;
      font-weight: 500;
      width: fit-content;

      &.positive {
        background-color: rgba(from var(--p-green-600) r g b / 0.1);
        color: var(--p-green-600);
      }
      &.negative {
        background-color: rgba(from var(--p-red-600) r g b / 0.1);
        color: var(--p-red-600);
      }
    }
  `],
  imports: [CommonModule]
})
export class DeltaDisplayComponent {
  @Input() value: number = 0;

  getChipSeverity(): any {
    if (this.value > 0) return 'positive';
    if (this.value < 0) return 'negative';
    return 'negative';
  }
}